import {inject, Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Injectable({
	providedIn: 'root'
})
export class LanguageService {
	private translateService = inject(TranslateService);

	private storageKey = 'lang';
	private defaultLanguage = 'es';
	private allowedLanguages = ['es', 'en'];

	constructor() {
	}

	public getLanguage(): string {
		const stored = localStorage.getItem(this.storageKey);
		if (!stored || !this.allowedLanguages.includes(stored)) {
			const browserLang = navigator.language.split('-')[0];
			if (this.allowedLanguages.includes(browserLang)) {
				return browserLang;
			}
			return this.defaultLanguage;
		}
		return stored;
	}

	public setLanguage(lang: string): void {
		if (!this.allowedLanguages.includes(lang)) {
			console.warn('lang ' + lang + ' is not in the allowed lang list');
			return;
		}
		localStorage.setItem(this.storageKey, lang);
		this.translateService.setFallbackLang(this.defaultLanguage);
		this.translateService.use(lang);
	}

	public autoResolveLanguage(): void {
		this.setLanguage(this.getLanguage());
	}
}
